export function isObjectEmpty(object: any): boolean {
  for (let key in object) {
    return false;
  }
  return true;
}

export function isObjectEmptyString(object: any): boolean {
  const stringfy = JSON.stringify(object);
  if (stringfy !== '{}' && stringfy !== '""') {
    return false;
  }
  return true;
}

export function isEqual(obj1: any, obj2: any): boolean {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
